function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';

class Lines extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderLine", line => {
      const lineGenerator = this.props.lineGenerator;
      const id = line.id,
            data = line.data,
            color = line.color;
      const className = "line  line--" + id;
      return React.createElement("path", {
        key: id,
        d: lineGenerator(data.map(d => ({
          x: d.position.x,
          y: d.position.y
        }))),
        stroke: color,
        fill: "none",
        className: className
      });
    });
  }

  render() {
    const series = this.props.series;
    return React.createElement("g", {
      className: "lines"
    }, series.map(this.renderLine));
  }

}

export default Lines;